import { api } from './client.js';

const root = '/admin/pets';

export const petsApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`),
  create: (body) => api.post(root, body),
  update: (id, body) => api.patch(`${root}/${id}`, body),
  remove: (id) => api.delete(`${root}/${id}`),
  uploadPhoto: (id, formData) => api.post(`${root}/${id}/photos`, formData),
  deletePhoto: (id, storageKey) => api.delete(`${root}/${id}/photos`, { body: { storageKey } })
};
